import { useTexts } from '@shared/translation';
import type { tableTexts } from './texts';

export interface TableTextTree {
  shared: {
    ui: {
      table: typeof tableTexts;
    };
  };
}

export function useTableTexts() {
  return useTexts<TableTextTree>().shared.ui.table;
}
